export const Curriculum = () => <div className="flex h-full items-center justify-center">Curriculum</div>;
